export interface Video {
  id: number;
  title: string;
  description: string;
  thumbnail: string;
  duration: string;
  category: string;
  views: number;
  rating: number;
  date: string;
  tags: string[];
  isFeatured: boolean;
  isHot: boolean;
}

export const videos: Video[] = [
  {
    id: 1,
    title: '流浪地球2：人类命运共同体的太空史诗',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对前所未有的危机，人类展现了空前的团结与勇气。本片以震撼的视觉效果和深刻的情感内核，呈现了一场跨越星河的壮丽冒险，探讨了人类文明在绝境中的坚韧与希望。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20astronauts%20and%20massive%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20photography%2C%20deep%20space%20background%20with%20stars%2C%20futuristic%20technology%2C%20atmospheric%20tone%2C%20professional%20film%20poster%20style&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '02:28:15',
    category: 'movie',
    views: 12580000,
    rating: 9.2,
    date: '2026-07-28',
    tags: ['科幻', '冒险', '太空', '国产大片'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 2,
    title: '繁花深处：上海滩的商战传奇',
    description: '上世纪九十年代初，煌煌大时代，人人争上游。阿宝从平凡青年蜕变为商界后起之秀的故事，在上海这座充满机遇与挑战的城市里徐徐展开。黄河路上，霓虹闪烁间，一幅波澜壮阔的时代画卷缓缓铺陈。',
    thumbnail: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20cinematic%20drama%20series%20poster%20style%2C%20warm%20golden%20toned%20photography%2C%20nostalgic%20atmosphere%2C%20Chinese%20urban%20landscape&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '45:30',
    category: 'tv',
    views: 9870000,
    rating: 9.4,
    date: '2026-07-25',
    tags: ['都市', '商战', '年代', '热播'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 3,
    title: '向往的生活·山海篇：田园牧歌之旅',
    description: '一群好友远离都市喧嚣，来到山海之间的静谧小屋，过起自给自足的田园生活。每一期都有新朋友到访，在炊烟袅袅中分享人生故事，在星空下畅谈理想与远方。真实、温暖、治愈，这是属于每个人的向往生活。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20countryside%20cottage%20with%20garden%20and%20mountains%20in%20background%2C%20warm%20sunset%20lighting%2C%20cozy%20rustic%20atmosphere%2C%20variety%20show%20style%20photography%2C%20green%20rice%20fields%2C%20peaceful%20rural%20scene&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '01:35:20',
    category: 'variety',
    views: 8560000,
    rating: 8.9,
    date: '2026-07-26',
    tags: ['综艺', '生活', '治愈', '田园'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 4,
    title: '深海寻梦：一场关于勇气的奇幻冒险',
    description: '少女参宿在神秘的海底世界展开了一段奇幻冒险。五彩斑斓的深海生物、光怪陆离的水下奇观、温暖人心的相遇与告别。这部历时七年打造的动画大片，以绝美的画面呈现了一个关于勇气、友情与成长的动人故事。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20world%20with%20colorful%20coral%20reefs%20and%20glowing%20jellyfish%2C%20animated%20movie%20style%2C%20dreamy%20fantasy%20atmosphere%2C%20deep%20ocean%20with%20sunlight%20rays%2C%20beautiful%20artistic%20rendering&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '01:52:08',
    category: 'anime',
    views: 7230000,
    rating: 9.3,
    date: '2026-07-20',
    tags: ['动画', '奇幻', '冒险', '国产'],
    isFeatured: true,
    isHot: false,
  },
  {
    id: 5,
    title: '极境之旅：探秘世界屋脊的生命奇迹',
    description: '穿越青藏高原的壮美山河，记录这片世界屋脊上独特的生态系统。从雪山之巅到峡谷深处，从珍稀野生动物到淳朴的藏地人文，以4K超高清镜头捕捉大自然的鬼斧神工，展现人与自然和谐共生的壮丽诗篇。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20Tibetan%20plateau%20landscape%20with%20snow-capped%20mountains%20and%20blue%20sky%2C%20documentary%20film%20style%2C%20dramatic%20natural%20lighting%2C%20wild%20animals%20in%20distance%2C%20pristine%20wilderness%2C%20aerial%20photography&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '00:58:40',
    category: 'documentary',
    views: 4120000,
    rating: 9.6,
    date: '2026-07-18',
    tags: ['纪录片', '自然', '高原', '4K'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 6,
    title: '城市漫步：成都烟火气中的慢生活',
    description: '跟随镜头穿梭在成都的大街小巷，感受这座千年古都的独特魅力。从清晨的盖碗茶到深夜的火锅店，从宽窄巷子的青砖黛瓦到太古里的时尚潮流。这里有最地道的川味美食，最悠闲的生活节奏，最热情的成都人。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chengdu%20old%20street%20with%20traditional%20tea%20house%20and%20bamboo%20chairs%2C%20warm%20afternoon%20sunlight%2C%20local%20people%20enjoying%20tea%2C%20Sichuan%20cultural%20atmosphere%2C%20vibrant%20street%20food%20scene&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '00:12:35',
    category: 'short',
    views: 3150000,
    rating: 9.0,
    date: '2026-07-27',
    tags: ['短视频', '城市', '美食', '旅行'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 7,
    title: '龙腾虎跃：中国功夫的千年传承',
    description: '从少林寺到武当山，从咏春拳到太极拳，这部纪录片深入探访中国武术各大流派的传承与发展。老中青三代武术家的真实故事，精湛技艺的震撼展示，让你重新认识中华武术的深厚底蕴与时代魅力。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20martial%20arts%20master%20practicing%20in%20ancient%20temple%20courtyard%2C%20morning%20mist%20atmosphere%2C%20dramatic%20lighting%2C%20cultural%20heritage%20theme%2C%20cinematic%20documentary%20style&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '01:15:22',
    category: 'documentary',
    views: 2890000,
    rating: 9.1,
    date: '2026-07-15',
    tags: ['纪录片', '功夫', '文化', '传承'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 8,
    title: '长安十二时辰：盛唐风云录',
    description: '天宝三载，上元节前夕，长安城陷入一场惊天阴谋。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。精美的服化道、考究的历史细节、紧张刺激的剧情节奏，带你领略大唐盛世的恢弘气象。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Tang%20Dynasty%20Chinese%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20historical%20drama%20atmosphere%2C%20epic%20cinematic%20photography%2C%20warm%20fire%20light%2C%20crowded%20ancient%20marketplace&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '45:00',
    category: 'tv',
    views: 11050000,
    rating: 9.5,
    date: '2026-07-10',
    tags: ['古装', '悬疑', '历史', '精品'],
    isFeatured: true,
    isHot: false,
  },
  {
    id: 9,
    title: '声生不息·金曲季：经典旋律的时代回响',
    description: '顶级的歌手阵容、精良的音乐制作，每一首金曲都承载着几代人的记忆与情感。从经典老歌到当代流行，从民族音乐到世界之声，跨越时空的音乐盛宴，在熟悉的旋律中找到共鸣与感动。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20colorful%20lights%20and%20orchestra%2C%20professional%20live%20performance%20photography%2C%20dramatic%20stage%20lighting%2C%20emotional%20atmosphere%2C%20music%20show%20production&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '01:48:30',
    category: 'music',
    views: 6780000,
    rating: 9.0,
    date: '2026-07-22',
    tags: ['音乐', '演唱会', '金曲', 'live'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 10,
    title: '星际征途：人类探索宇宙的壮丽篇章',
    description: '从第一颗人造卫星到载人登月，从火星探测到深空旅行，人类探索宇宙的脚步从未停歇。以第一手影像资料和专家深度解读，全景展现人类航天事业的辉煌成就与未来展望，激发每个人心中的星辰大海。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Rocket%20launch%20at%20night%20with%20dramatic%20flames%20and%20smoke%2C%20space%20exploration%20theme%2C%20scientific%20documentary%20style%2C%20star-filled%20sky%2C%20futuristic%20spacecraft%2C%20inspiring%20cinematic%20scene&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '01:05:18',
    category: 'documentary',
    views: 3450000,
    rating: 9.4,
    date: '2026-07-08',
    tags: ['纪录片', '太空', '科技', '探索'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 11,
    title: '笑傲江湖·喜剧盛典：爆笑不停歇',
    description: '汇聚全国顶尖喜剧人才，涵盖相声、小品、脱口秀、即兴喜剧等多种喜剧形式。包袱密集、笑点不断，在欢声笑语中传递生活的温暖与智慧。放下疲惫，开怀大笑，这就是最好的解压方式。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedy%20show%20stage%20with%20performers%20and%20bright%20colorful%20lighting%2C%20laughing%20audience%2C%20entertainment%20show%20atmosphere%2C%20stand-up%20comedy%20style%2C%20vibrant%20and%20energetic%20scene&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '01:22:15',
    category: 'variety',
    views: 9320000,
    rating: 8.8,
    date: '2026-07-24',
    tags: ['综艺', '喜剧', '搞笑', '解压'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 12,
    title: '敦煌秘境：丝路明珠的千年回眸',
    description: '深入敦煌莫高窟，揭开千年壁画的神秘面纱。从乐尊和尚开窟到藏经洞的惊世发现，从飞天壁画的飘逸灵动到丝绸之路的繁华盛景。以高清影像和专家解读，带领观众穿越时空，感受这座人类文明瑰宝的永恒魅力。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dunhuang%20Mogao%20Caves%20with%20ancient%20Buddhist%20murals%20and%20desert%20landscape%2C%20cultural%20heritage%20site%2C%20warm%20golden%20desert%20light%2C%20Silk%20Road%20theme%2C%20historical%20documentary%20photography&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '00:52:40',
    category: 'documentary',
    views: 2670000,
    rating: 9.3,
    date: '2026-07-05',
    tags: ['纪录片', '敦煌', '文化', '丝路'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 13,
    title: '动漫大赏：年度最佳动画作品合集',
    description: '精选本年度最具人气的动画作品，涵盖热血、治愈、奇幻、科幻等多种风格。从国产精品到国际佳作，从长篇连载到独立短片，为动漫爱好者打造一场视觉与情感的盛宴。每一帧画面都凝聚着动画人的匠心与热爱。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20art%20collage%20with%20various%20characters%20and%20scenes%2C%20vibrant%20animation%20style%2C%20Japanese%20and%20Chinese%20animation%20aesthetic%2C%20dynamic%20composition%2C%20professional%20anime%20poster%20design&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '02:05:30',
    category: 'anime',
    views: 5890000,
    rating: 9.0,
    date: '2026-07-21',
    tags: ['动画', '合集', '年度', '精选'],
    isFeatured: true,
    isHot: false,
  },
  {
    id: 14,
    title: '舌尖上的家乡味：记忆中最温暖的滋味',
    description: '走遍大江南北，寻访散落在各地的家乡味道。从东北的酸菜炖粉条到广东的老火靓汤，从四川的麻辣火锅到江南的清甜糕点。每一道菜背后都是一个关于家和爱的故事，让你的味蕾在熟悉的滋味中找到归属。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20family%20dinner%20table%20with%20various%20dishes%2C%20warm%20home%20kitchen%20lighting%2C%20steaming%20hot%20food%2C%20rustic%20cooking%20scene%2C%20appetizing%20food%20photography%2C%20cultural%20cuisine&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '00:48:25',
    category: 'short',
    views: 4560000,
    rating: 9.2,
    date: '2026-07-23',
    tags: ['短视频', '美食', '家乡', '温情'],
    isFeatured: false,
    isHot: true,
  },
  {
    id: 15,
    title: '风云再起：武侠世界的英雄本色',
    description: '江湖恩怨，快意恩仇。一代大侠郭靖镇守襄阳，面对蒙古铁骑的步步紧逼，演绎了一曲荡气回肠的英雄赞歌。精湛的武打场面、深刻的人物刻画、宏大的战争场景，重新定义新武侠美学，让经典在新时代焕发光彩。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20battle%20scene%20on%20ancient%20city%20wall%2C%20dramatic%20sunset%20sky%2C%20warriors%20in%20traditional%20armor%2C%20cinematic%20movie%20poster%20style%2C%20heroic%20atmosphere%2C%20sweeping%20landscape&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '02:15:40',
    category: 'movie',
    views: 14520000,
    rating: 9.1,
    date: '2026-07-12',
    tags: ['武侠', '动作', '古装', '院线'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 16,
    title: '2026华语音乐盛典：年度金曲颁奖典礼',
    description: '华语乐坛年度最高荣誉，汇聚两岸三地最闪耀的音乐明星。从最佳新人到年度金曲，从最佳专辑到终身成就奖，见证华语音乐的荣耀时刻。震撼的舞台效果、精彩的现场表演，这是一场属于音乐爱好者的年度狂欢。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20award%20ceremony%20stage%20with%20golden%20trophies%20and%20spotlights%2C%20music%20awards%20show%2C%20elegant%20red%20carpet%20atmosphere%2C%20professional%20event%20photography%2C%20glamorous%20celebration%20scene&width=800&height=450&seq=video-thumb-16&orientation=landscape',
    duration: '02:35:00',
    category: 'music',
    views: 8230000,
    rating: 9.3,
    date: '2026-07-30',
    tags: ['音乐', '颁奖', '盛典', '华语'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 17,
    title: '动物王国：非洲大草原的生命赞歌',
    description: '跟随野生动物摄影师的镜头，深入非洲大草原的心脏地带。见证角马大迁徙的磅礴气势，感受狮群狩猎的紧张刺激，惊叹于大自然中每一个生命的顽强与美丽。这不仅是一部纪录片，更是一封写给地球生命的情书。',
    thumbnail: 'https://readdy.ai/api/search-image?query=African%20savanna%20sunset%20with%20wild%20animals%20silhouettes%2C%20lions%20and%20elephants%20in%20golden%20light%2C%20nature%20documentary%20style%2C%20dramatic%20sky%2C%20wide%20open%20landscape%2C%20professional%20wildlife%20photography&width=800&height=450&seq=video-thumb-17&orientation=landscape',
    duration: '01:20:10',
    category: 'documentary',
    views: 3780000,
    rating: 9.5,
    date: '2026-07-01',
    tags: ['纪录片', '动物', '自然', '非洲'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 18,
    title: '都市夜话：当代年轻人的情感观察',
    description: '聚焦当代都市年轻人的情感世界，通过真实故事访谈和专家深度分析，探讨爱情、友情、亲情在快节奏生活中的变迁与坚守。温暖治愈的叙事风格，引人深思的话题讨论，让每个在都市中前行的人找到共鸣。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20city%20night%20scene%20with%20young%20people%20sitting%20in%20cozy%20cafe%2C%20warm%20interior%20lighting%2C%20intimate%20conversation%20atmosphere%2C%20urban%20lifestyle%20photography%2C%20emotional%20documentary%20style&width=800&height=450&seq=video-thumb-18&orientation=landscape',
    duration: '00:35:50',
    category: 'short',
    views: 2340000,
    rating: 8.7,
    date: '2026-07-19',
    tags: ['短视频', '情感', '都市', '访谈'],
    isFeatured: false,
    isHot: false,
  },
  {
    id: 19,
    title: '盗墓笔记·终极笔记：地宫深处的惊世之谜',
    description: '吴邪与张起灵再度踏上冒险之旅，深入神秘的古墓探寻失落的文明。惊险刺激的地下探险、环环相扣的悬疑情节、震撼的视觉特效，带你体验前所未有的奇幻冒险。真相就在前方，你敢一同前行吗？',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20underground%20tomb%20with%20torches%20and%20ancient%20carvings%2C%20adventure%20movie%20atmosphere%2C%20dramatic%20lighting%20from%20torches%2C%20dark%20mysterious%20corridor%2C%20thriller%20exploration%20scene&width=800&height=450&seq=video-thumb-19&orientation=landscape',
    duration: '01:58:30',
    category: 'movie',
    views: 16780000,
    rating: 8.9,
    date: '2026-07-29',
    tags: ['冒险', '悬疑', '盗墓', '特效'],
    isFeatured: true,
    isHot: true,
  },
  {
    id: 20,
    title: '国乐大典：千年雅韵的时代新声',
    description: '当千年古筝遇到电子音乐，当琵琶与交响乐交融，传统国乐在当代焕发出全新的生命力。顶尖国乐演奏家与创新音乐人的精彩合作，在经典与潮流的碰撞中，让国乐之美被更多年轻人听见和喜爱。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20musical%20instruments%20performance%20on%20modern%20stage%2C%20guzheng%20and%20pipa%20with%20dramatic%20lighting%2C%20cultural%20fusion%20concert%2C%20elegant%20artistic%20atmosphere%2C%20professional%20music%20photography&width=800&height=450&seq=video-thumb-20&orientation=landscape',
    duration: '01:10:45',
    category: 'music',
    views: 3120000,
    rating: 9.1,
    date: '2026-07-16',
    tags: ['音乐', '国乐', '创新', '文化'],
    isFeatured: false,
    isHot: false,
  },
];